import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  activationRequest: ['key', 'history'],
  activationSuccess: null,
  activationFailure: ['error'],
});

export const ActivationTypes = Types;
export default Creators;



// WEBPACK FOOTER //
// ./src/state/actions/ActivationActions.js